import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParentService } from '@app/dashboard/services/parent.service';
import {ToastrService} from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import {Path} from '@core/enums';

@Component({
  selector: 'app-active-reviews',
  templateUrl: './active-reviews.component.html',
  styleUrls: ['./active-reviews.component.scss']
})
export class ActiveReviewsComponent implements OnInit {
  // tslint:disable-next-line:ban-types
  isMobileDevice: Boolean;
  reviews =  []; // All completed reviews will store here
  areaOfFocusId: string;
  areaOfFocus = [];
  availableCreditInformation = []; // Get user credit information


  // tslint:disable-next-line:variable-name
  constructor(private parentService: ParentService,
              private toastr: ToastrService,
              private router: Router) {
    this.isMobileDevice = true;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }

  ngOnInit(): void {
    this.loadAreasOfFocus();
  }

  gabadooReviewClicked(reviewInfo){
    this.router.navigateByUrl('/gaba-plan/' + reviewInfo.reviewDetails._id, { state: reviewInfo });
  }

  getActiveReviews() {
    this.parentService.getActiveGabadooReviews().subscribe((response) => {
      this.reviews = response.body.result;
      this.assignCorrectProblemNamesToCards(response.body.result);
    });
  }

  loadAreasOfFocus() {
    this.parentService.getAreasOfFocus().subscribe((response) => {
      if (response.status === 200) {
        this.areaOfFocus.push.apply(this.areaOfFocus, response.body.result);
        this.getActiveReviews();
      } else {
        this.toastr.error('Encountered problem loading Areas Of Focus Info', 'Error!');
      }
    }, (error => this.toastr.error(error, 'Error!')));
  }

  assignCorrectProblemNamesToCards(responseArray){
    responseArray.forEach((element, index) => {
      this.areaOfFocusId = element.reviewDetails.areaOfFocus;
      const selectedAreaFocusDetail = this.areaOfFocus.find(area => area._id === this.areaOfFocusId);
      this.reviews[index].reviewDetails.areaOfFocus = selectedAreaFocusDetail.problemName;
    });
  }

  // Check the account available credit information
  getAccountAvailableCreditInformation() {
    this.parentService.accountAvailableCreditInformation().subscribe((response) => {
      console.log('response', response);
      if (response.status === 200) {
        this.availableCreditInformation = response.body.result;
        if (this.availableCreditInformation.length > 0) {
          // Need to update it
          this.router.navigate([`/${Path.ParentHome}/${Path.CreateGabadoo}`]);
        }else {
          this.router.navigate([`/${Path.ParentHome}/${Path.Payment}`]);
          this.toastr.info(`You need credits to create a new Gabadoo Review, you can add more here`);
        }
      }else {
        this.router.navigate([`/${Path.ParentHome}/${Path.Payment}`]);
        this.toastr.info(`You need credits to create a new Gabadoo Review, you can add more here`);
      }
    }, (error) => {
      console.log('error', error);
    });
  }

  goToCreateGabaPage() {
    this.getAccountAvailableCreditInformation();
  }

}
